import React, { useState, useEffect } from 'react';
import { AnimatedLetters } from '../common/AnimationFramer';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
const slides = [
  {
    id: 1,
    img: '/slider1.jpg',
    title: 'Our Clients Are At The Center',
    bottom: 'OF WHAT WE DO',
    desc: 'We provide industry-leading protection for your business.',
  },
  {
    id: 2,
    img: '/slider2.jpg',

    title: 'Serving & Protecting',
    bottom: 'YOUR INTERESTS',
    desc: 'Monitor everything in real-time with our advanced systems.',
  },
  {
    id: 3,
    img: '/slider3.jpg',
    title: 'Professional & Powerful',
    bottom: 'SECURITY PROTECTION',
    desc: 'We deliver unmatched safety and peace of mind.',
  },
];

export default function HomeHero() {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();
  // Auto slide every 5s
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div
      style={{ backgroundImage: `url('/herobg.jpg')` }}
      className="relative mt-[-11rem] flex h-[calc(100vh+9rem)] w-full items-center justify-center overflow-hidden bg-cover font-inter md:h-[calc(100vh+11rem)]"
    >
      <div
        className="absolute left-0 top-0 z-[0] h-full w-full"
        style={{ backgroundImage: 'linear-gradient(180deg, #00142CD6 15%, #00142C 100%)' }}
      ></div>
      {/* Slides */}

      {/* Dots */}
      {/* <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 gap-3">
        {slides.map((_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            className={`h-3 w-3 cursor-pointer rounded-full ${i === index ? 'bg-white' : 'bg-white/40'}`}
          ></div>
        ))}
      </div>     */}
      <div className="z-[1334] w-full max-w-[116rem] px-[2rem]">
        <div className="flex w-full flex-row-reverse flex-wrap items-center justify-center gap-y-[4rem] md:flex-row md:justify-between">
          <motion.div
            className="w-full md:hidden md:w-[45%]"
            initial={{ x: 0, opacity: 0 }} // start off to the left
            whileInView={{ x: 0, opacity: 1 }} // slide into place
            transition={{ duration: 0.8, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.5 }} // animate once when 50% visible
          >
            <img
              src="/removebgnew.gif"
              alt="heroinside"
              className="mt-[-4rem] h-auto w-full bg-cover"
            />
          </motion.div>
          <div className="w-full md:w-[55%]">
            <h1 className="w-full text-[3rem] font-[700] leading-[4rem] text-white lg:text-[5.2rem] lg:leading-[6.76rem]">
              Professional{' '}
              <span className="text-[#0ec9ac]">
                <AnimatedLetters
                  key={index}
                  word={`${index === 0 ? 'Company' : index === 1 ? 'Security' : 'Protection'}`}
                />
              </span>
              <br /> With Reliable Service
            </h1>
            <p className="mt-[2rem] text-[1.6rem] font-[400] leading-[2.4rem] text-[#828FA0]">
              {' '}
              WITH Next-G Services, YOU, YOUR FAMILY AND YOUR COMPANY ARE FULLY PROTECTED
            </p>

            <motion.h1
              className="border-box mt-[4rem] flex h-[4.4rem] w-[20rem] cursor-pointer items-center justify-center rounded-md bg-[#0EC9AC] text-[1.6rem] font-[600] text-white lg:h-[6.4rem]"
              whileHover="hover"
              variants={{
                hover: { transition: { staggerChildren: 0.05 } },
              }}
            >
              {'CONTACT US'.split('').map((letter, i) => (
                <motion.span
                  key={i}
                  onClick={() => {
                    navigate('/contact-us');
                  }}
                  className="inline-block"
                  variants={{
                    hover: {
                      y: -5,
                      scale: 1.2,
                      transition: { type: 'spring', stiffness: 300, damping: 20 },
                    },
                  }}
                >
                  {letter === ' ' ? '\u00A0' : letter} {/* non-breaking space for spaces */}
                </motion.span>
              ))}
            </motion.h1>
          </div>
          <motion.div
            className="hidden w-full flex-wrap justify-center md:flex md:w-[45%]"
            initial={{ x: 200, opacity: 0 }} // start off to the right
            whileInView={{ x: 0, opacity: 1 }} // slide into final position
            transition={{ duration: 0.8, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.5 }} // animate once when 50% visible
          >
            <img
              src="/removebgnew.gif"
              alt="heroinside"
              className="mt-[-4rem] h-auto w-[60rem] bg-cover"
            />
          </motion.div>
        </div>{' '}
      </div>
    </div>
  );
}
